
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import PickerInputMixin from "@/mixins/PickerInputMixin.vue";
import CACHE_STORAGE_ICW from "sls-cache";

CACHE_STORAGE_ICW.config({ cacheName: "ICW_CACHE", defaultTTL: 60 * 24 });

@Component({})
export default class DatabasePicker extends Mixins(PickerInputMixin) {
  @Prop() action!: string;
  @Prop({ default: "isim" }) itemText!: string;  @Prop() autoComplete: any;
  @Prop() rules: any;
  @Prop() placeHolder!: any;
  @Prop() disabled: any;
  @Prop() defaultLast: any;
  @Prop() hideDetails!: string | boolean;
  @Prop() defaultId!: number;
  @Prop() readonly!: string | boolean;
  @Prop({ default: "Bu görünümde veri yok." }) noDataText!: string;  @Prop() cacheActive!: string | boolean;
  @Prop({ default: 60 }) cacheTTL!: number;
  @Prop() filterFunction!: Function;
  @Prop({ default: false }) defaultFirstItem!: boolean;

  localItemText: string = "";
  isLoading = false;
  private cacheMap = new Map<string, number>();
  private static pendingRequests = new Map<string, Promise<any>>();

  // PickerInputMixin'den gelen özellikler
  declare items: Array<any>;
  declare selectedItem: any;
  declare input: () => void;

  get isAutoComplete() { return this.autoComplete || this.autoComplete === ""; }
  get isDisabled()      { return this.disabled || this.disabled === ""; }
  get isHideDetails()   { return this.hideDetails || this.hideDetails === ""; }
  get isReadonly()      { return this.readonly || this.readonly === ""; }
  get isCacheActive()   { return this.cacheActive || this.cacheActive === ""; }

  @Watch("action") onActionChange() { this.load(); }
  @Watch("filterFunction") onFilterFunctionChange() { this.load(); }

  @Watch("selectedItem")
  onSelectedItemChange() {
    if (this.selectedItem && (this.selectedItem as any).id != null) {
      this.$emit("selected-item", this.selectedItem);
    }
  }

  @Watch("defaultId")
  onDefaultIdChange() {
    if (this.defaultId && Array.isArray(this.items)) {
      const found = this.items.find((i: any) => i.id == this.defaultId);
      if (found) this.selectedItem = found;
    }
  }

  mounted() {
    this.localItemText = this.itemText;    // items'in daima Array olmasını garanti et
    if (!Array.isArray(this.items)) this.items = [];
    this.load();
  }

  async load() {
    if (!this.action) return;
    this.isLoading = true;
    try {
      let response: any;

      if (this.isCacheActive) {
        const cacheKey = this.$helper.hash(this.action);

        // 1. Önce cache'e bak
        const cachedData = CACHE_STORAGE_ICW.get<any>(cacheKey);
        if (cachedData) {
          const hitCount = (this.cacheMap.get(cacheKey) || 0) + 1;
          this.cacheMap.set(cacheKey, hitCount);
          if (hitCount > 5) {
            const extendedTTL = Math.min(this.cacheTTL * 2, 60 * 24 * 7);
            CACHE_STORAGE_ICW.set(cacheKey, cachedData, extendedTTL);
          }
          response = cachedData;
        } else {
          // 2. Cache'de yok, pending request var mı kontrol et
          const pendingRequest = DatabasePicker.pendingRequests.get(cacheKey);
          if (pendingRequest) {
            // Aynı istek zaten yapılıyor, onu bekle
            response = await pendingRequest;
          } else {
            // 3. Yeni istek yap ve pending olarak kaydet
            const requestPromise = this.$http.get(this.action);
            DatabasePicker.pendingRequests.set(cacheKey, requestPromise);

            try {
              response = await requestPromise;
              CACHE_STORAGE_ICW.set(cacheKey, response, this.cacheTTL);
            } finally {
              // İstek tamamlandı, pending'den kaldır
              DatabasePicker.pendingRequests.delete(cacheKey);
            }
          }
        }
      } else {
        response = await this.$http.get(this.action);
      }

      const rawData = response.data && response.data.hasOwnProperty("data")
          ? response.data.data
          : response.data;

      const raw = this.filterFunction
          ? this.filterFunction(rawData)
          : rawData;

      // her durumda Array'e çevir
      this.items = Array.isArray(raw) ? raw : (raw ? [raw] : []);

      if (this.defaultLast && this.items.length) {
        this.selectedItem = this.items[this.items.length - 1];
        this.input();
      } else if (this.defaultId) {
        const found = this.items.find((i: any) => i.id == this.defaultId);
        if (found) {
          this.selectedItem = found;
          this.input();
        }
      } else if (this.defaultFirstItem && this.items.length === 1 && !this.selectedItem) {
        this.selectedItem = this.items[0];
        this.input();
      }

      this.$emit("items", this.items);
    } finally {
      this.isLoading = false;
    }
  }
}
